import { Trans, useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

import { Colors } from '@zendesk/forethought-elements';

export const UnsecuredPage = () => {
  const { t } = useTranslation('security');

  return (
    <Container>
      <Title>{t('unsecuredPage.title')}</Title>
      <Body>{t('unsecuredPage.body')}</Body>
      <Body>
        <Trans
          components={{
            wikipediaLink: (
              <a
                href='https://en.wikipedia.org/wiki/Clickjacking'
                rel='noopener noreferrer'
                target='_blank'
              />
            ),
          }}
          i18nKey='unsecuredPage.learnMore'
          t={t}
        />
      </Body>
    </Container>
  );
};

const Container = styled('section')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled('h1')`
  color: ${Colors.ui.semantic.destructive.default};
  font-size: 30px;
`;

const Body = styled('p')`
  font-size: 22px;
`;
